import { render, staticRenderFns } from "./gain-loss-table-chart.vue?vue&type=template&id=5fd74e7d&"
import script from "./gain-loss-table-chart.vue?vue&type=script&lang=js&"
export * from "./gain-loss-table-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
